<template>
  <div class="d-flex flex-column flex-center min-vh-100 bg-light">
    <div class="card shadow-sm w-100" style="max-width: 500px">
      <div class="card-body text-center py-10 px-8">
        <i class="fad fa-lock-alt text-danger mb-5" style="font-size: 4rem"></i>
        <h2 class="mb-3">{{ trans('Accès refusé') }}</h2>
        <p class="text-muted mb-6">
          {{ message || trans("Vous n'avez pas les droits nécessaires pour accéder à cette page.") }}
        </p>
        <div v-if="checking" class="text-muted mb-5">
          <i class="fad fa-sync fa-spin me-2"></i>{{ trans('Vérification des accès...') }}
        </div>
        <div class="d-flex flex-column gap-3">
          <button class="btn btn-primary" @click="retry" :disabled="checking" v-if="targetPath">
            <i class="fad fa-sync me-2"></i>{{ trans('Réessayer') }}
          </button>
          <button class="btn btn-light-primary" @click="goBack" v-if="canGoBack">
            <i class="fad fa-arrow-left me-2"></i>{{ trans('Retour') }}
          </button>
          <router-link :to="{name: 'home'}" class="btn btn-light">
            <i class="fad fa-home me-2"></i>{{ trans('Accueil') }}
          </router-link>
          <button class="btn btn-light-danger" @click="logout">
            <i class="fad fa-sign-out-alt me-2"></i>{{ trans('Se déconnecter') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import {auth} from "@/services/Auth";
import {api} from "@/services/Api";
import store from "@/store";

// Protection anti-boucle : une seule tentative automatique par chargement de page.
let autoRetryDone = false;

@Component({})
export default class Unauthorized extends Vue {
  checking = false

  get message(): string {
    return (this.$route.query.message as string) || ''
  }

  get targetPath(): string | null {
    return (this.$route.query.targetPath as string) || null
  }

  get canGoBack(): boolean {
    return window.history.length > 1
  }

  async mounted() {
    // Recharge le menu depuis auth puis tente de revenir sur la page cible.
    // Exécuté une seule fois (flag module-level) : si le guard refuse encore,
    // on reste sur access-denied sans relancer.
    if (this.targetPath && !autoRetryDone) {
      autoRetryDone = true
      await this.retry()
    }
  }

  async retry() {
    if (!this.targetPath) return
    this.checking = true
    // Recharge menu (accès globaux) + settings partner (restrictions perso) en parallèle.
    const tasks: Promise<any>[] = [
      api.get(api.auth, 'menu/list').then((res: any) => {
        if (res?.data?.menu) {
          store.state.mainStore.menus = res.data.menu
          localStorage.setItem('menus', JSON.stringify(res.data.menu))
        }
      }).catch(() => {}),
    ]
    if (auth.hasRole('ROLE_PARTNER')) {
      tasks.push(
        api.get(api.auth, 'auth/partner/settings/refresh').then((res: any) => {
          if (res?.data?.settings !== undefined) {
            store.state.settings = res.data.settings
            localStorage.setItem('settings', JSON.stringify(res.data.settings))
          }
        }).catch(() => {})
      )
    }
    await Promise.all(tasks)
    this.$router.replace(this.targetPath).catch(() => {
      this.checking = false
    })
  }

  goBack() {
    this.$router.go(-1)
  }

  logout() {
    auth.logout()
  }
}
</script>
